import type transform from '../to/locations';

export default (locations: ReturnType<typeof transform>) => {
  if (locations.length != new Set(locations.map(x => x.id)).size)
    throw new Error('(Core::From::V2::Locations) Location array have two or more locations with the same ID');

  return locations
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::Locations) Location id is undefined');

      return { ...x };
    });
};
